import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import { getMethod } from "../../../services/apiService";
import { getUserId } from "../../../helper/helper";
import { usePartnerIdContext  } from "../../../context/partnerIdContext";
import { Link } from "react-router-dom";
import search from "../../../assets/images/icon/search.svg"
import { PROFILE_TYPE } from "../../../helper/globalConstant";

interface LicenseData {
  license: {
    key: string;
    partner: string;
    data: {
      name: string;
      quantity: number;
      createdTime: number;
      activationTime: number;
      expiryTime: number;
      status: number;
      licenseType: number;
      analyticType: number;
    };
  };
  countData: {
    total: number;
    active: number;
    available: number;
  };
}
function LicenseTabOne() {
  //const [licenseData, setLicenseData] = useState<LicenseData[]>([]);
  const [licenseData, setLicenseData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [loader, showLoader] = useState(true);

  const handleCheckboxChange = (licenseKey: any) => {
    setSelectedRows((prev: any) =>
      prev.includes(licenseKey)
        ? prev.filter((key: any) => key !== licenseKey)
        : [...prev, licenseKey]
    );
  };

  const isRowSelected = (licenseKey: any) => selectedRows.includes(licenseKey);

  const [value, setValue] = useState(null);

  const { partnerId, setPartnerId } = usePartnerIdContext();

  useEffect(() => {
    if(partnerId) {
      fetchCustomerList();
    }
    const storedValue = localStorage.getItem('userInfo');
    if (storedValue) {
      setValue(JSON.parse(storedValue)?.email);
    }
  }, [partnerId]);
  
  let user = getUserId()


  const [filteredData, setFilteredData] = useState<LicenseData[]>([]);
  const fetchCustomerList = async () => {
    let partnerInfo
    const sess_user_data = localStorage.getItem("sess_user");
    if (sess_user_data != null) {
        try {
            const sess_user = JSON.parse(sess_user_data);
            const extractedProfileId = sess_user?.userProfile;
            if (extractedProfileId) {
            const priority = extractedProfileId?.priority;
            if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                partnerInfo = extractedProfileId?.ownerId;
            } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
                partnerInfo = partnerId
            }
            } else {
                console.error("Priority id not found in userProfile");
            }
        } catch (error) {
            console.error("Error parsing session user data:", error);
        }
    }
    const resp = await getMethod(`partner/license/available/${partnerInfo}`);
    if(resp?.data?.code === 200) {
      setFilteredData(resp?.data?.result);
      setLicenseData(resp?.data?.result);
      showLoader(false);
    } else {
      showLoader(false);
    }
  };


  
  
  const [searchText, setSearchText] = useState("")
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value.toLowerCase();
    setSearchText(searchText)
    const filtered = licenseData.filter((item) => {
      const { name } = item.license.data;
      const { available } = item.countData;

      return (
        name.toLowerCase().includes(searchText) ||
        available.toString().includes(searchText)
      );
    });

    setFilteredData(filtered); // Update the filtered data state
  }

  return (
    <>
      <Box sx={{ display: "flex", alignContent: "space-between", justifyContent: "space-between", gap: "32px", padding: "1rem" }}>
        <div
          style={{
            width: 468,
            height: 41,
            padding: 12,
            borderRadius: 30,
            border: "1px solid #5a5f60",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#1F2F34",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={search}
              alt="Search Icon"
              style={{ cursor: "pointer" }}
            />
            <input
              onChange={handleSearch}
              placeholder="Search by feature, availability."
              style={{
                background: "#1F2F34",
                border: "none",
                padding: 0,
                margin: 0,
                marginLeft: 8,
                color: "#FFF",
                width: 368,
              }}
            />
          </div>


        </div>
        <Link to="/orders/create" style={{
          textDecoration: "none",
          color: "inherit",

        }}>

          <button className="add-btn" style={{ cursor: "pointer" }}>
            Create New Order
          </button>
        </Link>

      </Box>
      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "#03171f", padding: "1rem" }}
      >
        <Table sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
          {/* Table Header */}
          <TableHead>
            <TableRow style={{ borderBottom: "2px solid #313838" }}>
              {/* <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              /> */}
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Feature
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Quantity
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Available
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Active
              </TableCell>

            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {filteredData?.length > 0 ? (
              filteredData?.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: isRowSelected(index)
                      ? "#1a2a2f"
                      : "inherit",
                    cursor: "pointer",
                  }}
                >
                  {/* Checkbox Column */}
                  {/* <TableCell
                    sx={{
                      color: "#B4B7B8",
                      borderColor: "#313838",
                      width: "50px",
                    }}
                  >
                    <Checkbox
                      checked={isRowSelected(index)}
                      onChange={() => handleCheckboxChange(index)}
                      sx={{ color: "#B4B7B8" }}
                    />
                  </TableCell> */}
                  {/* Data Columns */}
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {item?.license?.data?.name}

                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {item?.countData?.total}
                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >

                    {item?.countData?.available}

                  </TableCell>
                  <TableCell
                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                  >
                    {item?.countData?.active}

                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow sx={{ background: '#192529' }}>
                <TableCell
                  sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }}
                  colSpan={9}
                >
                  {loader ? (
                    <CircularProgress color="primary" />
                  ) : (
                    "No Data!"
                  )}
                </TableCell>
              </TableRow>
            )
          }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default LicenseTabOne